module.exports = __webpack_public_path__ + "img/780.12f22303.jpg";